const routers = [
   {
      path: '/',
      name: 'HomePage',
      component: () => import('../view/HomePage.vue')
   },
   {
      path: '/ActivateCard',
      name: 'ActivateCard',
      component: () => import('../view/ActivateCard.vue')
   },
   {
      path: '/DeleteCardPage',
      name: 'DeleteCardPage',
      component: () => import('../view/DeleteCardPage.vue')
   },
   {
      path: '/UsageGuidePage',
      name: 'UsageGuidePage',
      component: () => import('../view/UsageGuidePage.vue')
   },
   {
      path: '/ProblemFeedbackPage',
      name: 'ProblemFeedbackPage',
      component: () => import('../view/ProblemFeedbackPage.vue')
   },
   {
      path: '/UsageScenarioPage',
      name: 'UsageScenarioPage',
      component: () => import('../view/UsageScenarioPage.vue')
   },
   {
      path: '/PhoneTypePage',
      name: 'PhoneTypePage',
      component: () => import('../view/PhoneType.vue')
   },
   {
      path: '/LossPage',
      name: 'LossPage',
      component: () => import('../view/LossPage.vue')
   },
   {
      path: '/FeedBackListPage',
      name: 'FeedBackListPage',
      component: () => import('../view/FeedBackListPage.vue')
   },
   {
      path: '/FeedBackDetailsPage',
      name: 'FeedBackDetailsPage',
      component: () => import('../view/FeedBackDetailsPage.vue')
   },
   
]
export default routers;